import { bootstrapApplication } from '@angular/platform-browser';

import { ThemeMode, setThemeMode } from '@cpangular/ng-material-theme';
import { initializeApplication } from 'punchout-data';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// TODO: check if still needed
setThemeMode(ThemeMode.LIGHT);

initializeApplication(environment(), appConfig)
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err));
